export default __webpack_public_path__ + "static/media/logo-black.76e17d20.svg";